var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrainers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 23.292v.57C26 24.487 25.47 25 24.826 25h-9.359L2.352 12.278A1.107 1.107 0 012 11.481c0-.314.117-.598.352-.797l.41-.398 8.304 8.026 4.958 4.809c.03.029.058.057.088.057l.03.029c.03 0 .03.028.058.028.03 0 .03 0 .059.03H26v.027zm-.029-1.138c-.293-2.562-2.524-4.554-5.251-4.554h-1.321c-.03 0-.058-.029-.088-.029 0 0-.03 0-.03-.029-.03 0-.058-.029-.058-.056l-.03-.03c-.03-.028-.03-.056-.058-.056l-.03-.029-.91-1.195h-2.142a.58.58 0 01-.587-.57.58.58 0 01.587-.569h1.555c-.177-.569-.235-1.138-.177-1.707h-1.965a.58.58 0 01-.587-.57.58.58 0 01.587-.569h2.289c.205-.427.498-.825.85-1.195l1.174-1.138-2.084-2.022-2.494 2.42a.58.58 0 01-.822 0l-2.316-2.247v9.677l4.636 4.497h9.272v-.03zM6.928 6.216L3.584 9.46l3.344 3.244v-6.49zm3.961.654l-.645-.626a.554.554 0 01-.176-.398.55.55 0 01.176-.398l1.027-.996a.807.807 0 00.264-.598.767.767 0 00-.264-.598c-.352-.341-.91-.341-1.232 0l-1.907 1.85V13.9l2.757 2.675V6.87z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgTrainers;